module.exports = __webpack_public_path__ + "img/solu1.aff23fd8.png";